import React, { useCallback, useEffect } from 'react'
import { useApp } from '../../../context/AppProvider'
import { constructUrl } from '../../../services/common'
import { icon } from '../../../services/icon'
import { Parser } from '../../common'
import UpdateButton from '../what-is-your-situation/UpdateButton'

const GuidedResearch = ({ block, hearing }) => {
    const { setAttributesGuidedResearch } = useApp()
    const { validateSelection, setValidateSelection, setViewGeneralInformation } = useApp()

    const onClickUpdatedSelection = useCallback(() => {
        const hash = window.location.hash.substring(1)
        const paramsPart = hash.includes('?') ? hash.split('?')[1] : ''
        const idFicheParent = paramsPart.split('idFicheParent=')[1].split('&')[0]
        const urlWithSlash = constructUrl(idFicheParent, hearing)
        const url = urlWithSlash.endsWith('/') ? urlWithSlash.slice(0, -1) : urlWithSlash
        window.location.href = url
    }, [hearing])

    useEffect(() => {
        setAttributesGuidedResearch(block?.attributes)
    }, [block?.attributes])

    return (
        <div className="baseocom-guided-research-block">
            {!validateSelection ? (
                <h3 className="">
                    {icon('user-search-line')}
                    Quelle est votre situation ?
                </h3>
            ) : (
                <div className="baseocom-title-selected ">
                    <h3>
                        {icon('user-follow-line')}
                        Votre situation ?
                    </h3>
                    <UpdateButton updateFunction={onClickUpdatedSelection} />
                </div>
            )}
            {block?.childrens && <Parser content_block={block?.childrens} />}
        </div>
    )
}

export default GuidedResearch
